module.exports = __webpack_public_path__ + "img/jp.6a8f4d54.svg";